import React from "react";
import { SparklesIcon } from "lucide-react";
import type { OnboardingAnswers, SkillKey } from "../../../types/onboarding";
import { skillOptions } from "../../../data/onboarding";
import { OptionCard } from "../OptionCard";
import { StepHeading } from "../StepHeading";
import { Toggle } from "../../ui/Toggle";
import { suggestedFocus } from "../../../utils/placement";
interface FocusStepProps {
  answers: OnboardingAnswers;
  update: (p: Partial<OnboardingAnswers>) => void;
  onTouched: () => void;
}
export function FocusStep({
  answers,
  update,
  onTouched
}: FocusStepProps) {
  const suggested = suggestedFocus(answers.goals);
  const isSuggestion = suggested.length === answers.focus.length && suggested.every(s => answers.focus.includes(s));
  const toggle = (key: SkillKey) => {
    onTouched();
    const has = answers.focus.includes(key);
    if (has && answers.focus.length === 1) return; // keep at least one
    update({
      focus: has ? answers.focus.filter(f => f !== key) : [...answers.focus, key]
    });
  };
  return <div data-id="element-950" data-mp="1xkzbnhqd2omp">
      <StepHeading title="What do you want to get better at?" description="Lessons still cover everything — these just get extra practice." data-id="element-951" data-mp="1xk7e41d7egts" />

      {isSuggestion && answers.goals.length > 0 && <p className="mb-4 flex items-center gap-2 rounded-xl bg-accent/40 px-3.5 py-2.5 text-sm font-semibold text-ink" data-id="element-952" data-mp="1ojj0h7rq2ihf">
          <SparklesIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-953" data-mp="2gcs3v9xlw5td" /> Pre-picked from your reasons. Change anything.
        </p>}

      <ul className="grid gap-3 sm:grid-cols-2" data-id="element-954" data-mp="2lato3y6rqb6f">
        {skillOptions.map(s => <li key={s.key} data-id="element-955" data-mp="27cwmuohddglf">
            <OptionCard selected={answers.focus.includes(s.key)} onClick={() => toggle(s.key)} icon={s.icon} title={s.label} description={s.hint} data-id="element-956" data-mp="27blkmt3kogwf" />
          </li>)}
      </ul>

      <div className="mt-8 rounded-card border-3 border-line/30 bg-surface p-4" data-id="element-957" data-mp="vvwvpw6rd7sz">
        <Toggle checked={answers.speaking} onChange={speaking => update({
        speaking
      })} label="Speaking exercises" description="Turn off if you often learn on the go. You'll still hear all the audio." data-id="element-958" data-mp="10wb7npbhd1wa" />
      </div>
    </div>;
}